import { FederalTaxClassification, TinType } from "@common/types/counterparty";

export const TIN_TYPE_LABELS: Record<TinType, string> = {
    [TinType.SSN]: "SSN",
    [TinType.EIN]: "EIN",
};

export const TIN_MASKS: Record<TinType, string> = {
    [TinType.SSN]: "•••-••-••••",
    [TinType.EIN]: "••-•••••••",
};

export function getDefaultTinType(
    classification: FederalTaxClassification | null,
): TinType {
    return classification === null ||
        classification === FederalTaxClassification.INDIVIDUAL
        ? TinType.SSN
        : TinType.EIN;
}
